import { InventoryOptionMatch } from 'modules/inventoryOptions';

export enum EquipmentDetailsTabs {
  EquipmentInfo = 'Equipment Info',
  Attachments = 'Attachments',
  Media = 'Media',
}

export interface EquipmentAttachment {
  quantityPerAsset: number | null;
  type: string | null;
  manufacturer: string | null;
  model: string | null;
  category: string | null;
}

export interface EquipmentAsset {
  id: string;
  source: string;
  type: string;
  createdDateTime: string;
}

export interface EquipmentDetailsEquipment {
  equipmentId: string;
  year: string | null;
  make: string | null;
  model: string | null;
  modelBase: string | null;
  stockId: string | null;
  serialNumberVin: string | null;
  newUsed: string | null;
  mileage: number | null;
  classType: string | null;
  truckClass: number | null;
  assetTypeStr: string | null;
  type: string | null;
  style: string | null;
  hours: number | null;
  additionalDescription: string | null;
  wholesaleCost: number | null;
  totalWholesaleCost: number | null;
  retailPrice: number | null;
  discountType: string | null;
  discountValue: number | null;
  quantity: number | null;
  createdDateTime: string | null;
  modifiedDateTime: string | null;
  attachments: EquipmentAttachment[];
  specs: Record<string, unknown> | null;
  assets: EquipmentAsset[];
  options: InventoryOptionMatch[];
  inventoryItem: {
    inventoryId: string | null;
    status: string | null;
    condition: string | null;
  } | null;
}

export interface EquipmentDetailsResponse {
  equipment: EquipmentDetailsEquipment;
}

export interface EquipmentDetailsVariables {
  id: string;
}
